import {
  getJoinedConceptos,
  newDocumentoSelector,
} from "features/Crear/redux/selectors/newDocumentoSelectors"
import { newDocumentoSelectorDoc } from "features/Crear/redux/slices/newDocumentoSlice"
import { useSelector } from "hooks/useSelector"
import ConceptosTable from "../ConceptosTable"
import LibradoCard from "../LibradoCard"
import LibradorCard from "../LibradorCard"
import { formatFacturaRecurrenteLibrado } from "../NewFacturaRecurrente/constants"
import DocumentoFacturaRecurrenteFormHeader from "./DocumentoFacturaRecurrenteFormHeader"
import DocumentoFormDocumentosAsociados from "./DocumentoFormDocumentosAsociados"
import DocumentoFormHeader from "./DocumentoFormHeader"
import DocumentoFormInstruccionesDePago from "./DocumentoFormInstruccionesDePago"
import DocumentoFormOnservaciones from "./DocumentoFormOnservaciones"
import DocumentoFormTotales from "./DocumentoFormTotales"

const DocumentoForm = ({
  titleDocumento,
  searchArticulos = true,
  isLibrado,
  sinValorar,
  initialEmpresa,
  setObservacionCesion,
  observacionCesion,
  canEditLibradoLibrador,
  isFacturaRecurrente,
  facturaRecurrente,
  setSelectedClientFormaPago,
  setIsEditFormaPago,
}: $TSMigrationFixMe) => {
  const documento = useSelector(newDocumentoSelector)
  const retenecionRecurrente = useSelector(
    // @ts-expect-error TS(2339): Property 'documentos' does not exist on type 'Defa...
    (state) => state.documentos.facturaRecurrente.totalRetenido
  )
  const conceptos = useSelector(getJoinedConceptos)

  const { logo } = useSelector(newDocumentoSelectorDoc)

  return (
    <div className='documento-form-container'>
      {isFacturaRecurrente ? (
        <DocumentoFacturaRecurrenteFormHeader
          titleDocumento={titleDocumento}
          logo={logo}
        />
      ) : (
        <DocumentoFormHeader
          titleDocumento={titleDocumento}
          logo={logo}
          serie={documento.serie}
          numero={documento.numero}
          fechaEmision={documento.fechaEmision}
          fechaOperacion={documento.fechaOperacion}
          fechaVencimiento={documento.fechaVencimiento}
        />
      )}
      <div className='mt-3 row'>
        <div className='pr-3 text-left col-12 col-xl-6 pr-xl-2'>
          <LibradorCard canEditLibradoLibrador={canEditLibradoLibrador} />
        </div>

        <div className='col-12 col-xl-6'>
          <LibradoCard
            observacionCesion={observacionCesion}
            setObservacionCesion={setObservacionCesion}
            canEditLibradoLibrador={canEditLibradoLibrador}
            libradoRecurrente={
              facturaRecurrente &&
              formatFacturaRecurrenteLibrado(
                facturaRecurrente?.cliente,
                facturaRecurrente?.libradorId
              )
            }
            setSelectedClientFormaPago={setSelectedClientFormaPago}
          />
        </div>
      </div>

      <div className='table-articulos'>
        <ConceptosTable
          SearchArticulos={searchArticulos}
          isLibrado={isLibrado}
          sinValorar={sinValorar}
          initialEmpresa={initialEmpresa}
        />
      </div>

      <div className='mt-4 row'>
        <div className='col-lg-6'>
          <DocumentoFormOnservaciones
            observacionCesion={observacionCesion}
            observaciones={documento.observaciones}
          />

          <DocumentoFormInstruccionesDePago
            formaPagoDescription={documento.formaPagoDescription}
            formaPagoIban={documento.formaPagoIban}
            diasPago={documento.diasPago}
            setIsEditFormaPago={setIsEditFormaPago}
          />
        </div>

        {!sinValorar && (
          <DocumentoFormTotales
            isFacturaRecurrente={isFacturaRecurrente}
            documento={{ ...documento, retenecionRecurrente }}
            conceptos={conceptos}
          />
        )}
      </div>

      {documento.documentosAsociadosMsg && (
        <DocumentoFormDocumentosAsociados
          documentosAsociadosMsg={documento.documentosAsociadosMsg}
        />
      )}
    </div>
  )
}

export default DocumentoForm
